
import { getModel, Model } from "@/utils/models/model";
import { SaleConfigCalendarToShowField } from "@/utils/sale-config-calendar-to-show-field";
import Vue from "vue";
import AppColumnSelect from "@/components/models/ColumnSelect.vue";

export default Vue.extend({
	data(){
		return {
			toEditItem: null as null | SaleConfigCalendarToShowField,
			editProp: "ID"
		};
	},
	props: {
		fields: {
			type: Array as ()=>SaleConfigCalendarToShowField[],
			required: true
		},
		title: {
			type: String,
			required: true
		}
	},
	computed: {
		isNewEditItem():boolean {
			if (!this.toEditItem) return false;
			return this.fields.indexOf(this.toEditItem) == -1;
		},
		modalTitle():string {
			if (this.isNewEditItem){
				return this.$ct("add-new-calendar-field").toString();
			}
			return this.$ct("edit-calendar-field").toString();
		},
		model():Model{
			return getModel("Crm");
		}
	},
	methods: {
		emitChanged(){
			this.$emit("changed");
		},
		addClicked(){
			this.toEditItem = new SaleConfigCalendarToShowField();
			this.toEditItem.Prop = "ID";
			this.editProp = "ID";
		},
		getText(conf:SaleConfigCalendarToShowField):string{
			let f = this.model.getField(conf.Prop);
			if (!f) return "ERROR";
			return f.getPropertyTranslation();
		},
		confirm(){
			if (!this.toEditItem) return;
			this.toEditItem.Prop = this.editProp;
			if (this.isNewEditItem){
				this.fields.push(this.toEditItem);
			}
			this.toEditItem = null;
			this.emitChanged();
		},
		editItem(item:SaleConfigCalendarToShowField){
			this.toEditItem = item;
			this.editProp = item.Prop;
		},
		removeItem(item:SaleConfigCalendarToShowField){
			let i = this.fields.indexOf(item);
			if (i == -1) return;
			this.fields.splice(i, 1);
			this.emitChanged();
		}
	},
	components: {
		AppColumnSelect
	},
	i18nEx: {
		componentPrefix: "components.crm"
	}
});
